<template>
  <div id="app">
    <el-container>
      <el-aside width="66px">
        <navMenu />
      </el-aside>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import NavMenu from "./components/NavMenu.vue";
export default {
  components: { NavMenu },
  name: "App"
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue